// Heavy extras (the 3D bottles) wait for the visitor's first interaction, so they never compete with
// first paint. Until then the page shows the packshot photo. This is the "facade" pattern Lighthouse
// recommends for heavy embeds.

const EVENTS = [
  'pointermove',
  'pointerdown',
  'touchstart',
  'keydown',
  'wheel',
  'scroll',
] as const;

let interacted: Promise<void> | undefined;

/** Resolves once, on the first move, touch, key, wheel or scroll. */
export function firstInteraction(): Promise<void> {
  interacted ??= new Promise<void>((resolve) => {
    const done = () => {
      EVENTS.forEach((type) => window.removeEventListener(type, done, true));
      resolve();
    };
    EVENTS.forEach((type) =>
      window.addEventListener(type, done, { capture: true, passive: true }),
    );
  });
  return interacted;
}

/** Resolves when `el` is within `margin` of the viewport (and stays resolved). */
export function nearViewport(el: Element, margin = '400px'): Promise<void> {
  return new Promise((resolve) => {
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        resolve();
      },
      { rootMargin: margin },
    );
    io.observe(el);
  });
}
